import { BaseComponent } from './basecomponent';
import { OnInit } from '@angular/core';
//import { MessageService } from 'primeng/components/common/messageservice';
import { NoAuthorizationInterceptor } from './interceptor/NoAuthorizationInterceptor';
import { NGXLogger } from 'ngx-logger';
import { MessageService } from 'primeng/api';

export class PrincipalBaseComponent extends BaseComponent implements OnInit {

    constructor(
        private noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService,
        logger?: NGXLogger
    ) {
        super(messageService, logger);
    }

    ngOnInit() {
        this.noAuthorizationInterceptor.dataStream$().subscribe(errores => {
            this.messageService.clear();
            if (errores != undefined) {
                this.desbloquearPagina();
                this.messageService.addAll(this.getMensajesUsuario(errores));
            }
        });
    }
}